// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__13mAh","legacyBtn":"MutateMid_legacyBtn__1h6gB"};